export default function ContactInfo() {
  return (
    <div className="space-y-8">
      <div>
        <button
          onClick={() => {
            const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
            if (widget) widget.click();
          }}
          className="w-full border-2 border-primary text-primary px-6 py-4 rounded-xl font-inter font-medium text-base hover:bg-primary hover:text-white transition-colors whitespace-nowrap cursor-pointer"
        >
          Book a Call
        </button>
      </div>

      <div className="bg-gray-50 rounded-2xl p-6">
        <h3 className="font-inter font-semibold text-lg text-charcoal mb-4">
          Service Area
        </h3>
        <p className="font-inter text-base text-gray-700 leading-relaxed">
          Based in Charleston, IL — working with businesses nationwide
        </p>
      </div>

      <div className="bg-gray-50 rounded-2xl p-6">
        <h3 className="font-inter font-semibold text-lg text-charcoal mb-4">
          Contact Details
        </h3>
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <i className="ri-mail-line text-xl text-primary mt-0.5"></i>
            <div>
              <p className="font-inter text-sm text-gray-500 mb-1">Email</p>
              <a
                href="mailto:lacruedigitalagency@gmail.com"
                className="font-inter text-base text-gray-700 hover:text-primary transition-colors cursor-pointer"
              >
                lacruedigitalagency@gmail.com
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <i className="ri-phone-line text-xl text-primary mt-0.5"></i>
            <div>
              <p className="font-inter text-sm text-gray-500 mb-1">Phone</p>
              <a
                href="tel:+17204001546"
                className="font-inter text-base text-gray-700 hover:text-primary transition-colors cursor-pointer"
              >
                (720) 400-1546
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-2xl p-6">
        <h3 className="font-inter font-semibold text-lg text-charcoal mb-4">
          Follow Me
        </h3>
        <div className="flex items-center gap-4">
          <a
            href="https://instagram.com/lacruecole18"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-gray-700 hover:text-primary hover:bg-primary-light transition-colors cursor-pointer"
          >
            <i className="ri-instagram-line text-xl"></i>
          </a>
          <a
            href="https://facebook.com/lacruecole18"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-gray-700 hover:text-primary hover:bg-primary-light transition-colors cursor-pointer"
          >
            <i className="ri-facebook-line text-xl"></i>
          </a>
          <a
            href="https://twitter.com/lacruecole18"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-gray-700 hover:text-primary hover:bg-primary-light transition-colors cursor-pointer"
          >
            <i className="ri-twitter-x-line text-xl"></i>
          </a>
        </div>
      </div>
    </div>
  );
}